import React from 'react';
export var MastercardCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "master-card-art-title",
    "data-testid": "master-card-art",
    height: "24",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "master-card-art-title"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
    fill: "#FFF"
  }), React.createElement("circle", {
    cx: "15",
    cy: "12",
    fill: "#EB001B",
    r: "7"
  }), React.createElement("circle", {
    cx: "23",
    cy: "12",
    fill: "#F79E1B",
    r: "7"
  }), React.createElement("path", {
    d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7 0 2.3 1.2 4.5 3 5.7 1.8-1.2 3-3.3 3-5.7z",
    fill: "#FF5F00"
  })));
};
MastercardCardArt.defaultProps = {
  title: 'Mastercard'
};